module.exports = __webpack_public_path__ + "img/search inactive.4642dd65.svg";